import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const techSheetService = {
  list: (params) =>
    axios.get(`${API}/api/techsheets`, { ...auth(), params }).then(r => r.data),

  listForProduct: (productId) =>
    axios.get(`${API}/api/techsheets/product/${productId}`, auth()).then(r => r.data),

  get: (id) =>
    axios.get(`${API}/api/techsheets/${id}`, auth()).then(r => r.data),

  create: (productId) =>
    axios.post(`${API}/api/techsheets/product/${productId}`, {}, auth()).then(r => r.data),

  update: (id, data) =>
    axios.put(`${API}/api/techsheets/${id}`, data, auth()).then(r => r.data),

  approve: (id) =>
    axios.post(`${API}/api/techsheets/${id}/approve`, {}, auth()).then(r => r.data),

  delete: (id) =>
    axios.delete(`${API}/api/techsheets/${id}`, auth()).then(r => r.data),

  getComputedData: (productId) =>
    axios.get(`${API}/api/techsheets/product/${productId}/computed-data`, auth()).then(r => r.data),

  generateDescription: (data) =>
    axios.post(`${API}/api/techsheets/generate-description`, data, auth()).then(r => r.data),

  getImageUploadUrl: (fileName, contentType, fileSize) =>
    axios.post(`${API}/api/techsheets/upload-image-url`, { fileName, contentType, fileSize }, auth()).then(r => r.data),

  cloneFrom: (productId, sourceId) =>
    axios.post(`${API}/api/techsheets/product/${productId}/clone-from/${sourceId}`, {}, auth()).then(r => r.data),

  createPresentation: (techSheetId, data) =>
    axios.post(`${API}/api/techsheets/${techSheetId}/presentations`, data, auth()).then(r => r.data),

  updatePresentation: (techSheetId, blockId, data) =>
    axios.put(`${API}/api/techsheets/${techSheetId}/presentations/${blockId}`, data, auth()).then(r => r.data),

  deletePresentation: (techSheetId, blockId) =>
    axios.delete(`${API}/api/techsheets/${techSheetId}/presentations/${blockId}`, auth()).then(r => r.data),
};

export default techSheetService;
